import { render, staticRenderFns } from "./MonthlyCalendar.vue?vue&type=template&id=3540e042&"
import script from "./MonthlyCalendar.vue?vue&type=script&lang=ts&"
export * from "./MonthlyCalendar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports